import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { updateT } from "../../firebase/firebase";
import toast from "react-hot-toast";
import { getDueDate, payEmployee } from "../../web3hooks/contracthooks";
import "../../css/homepage.css";

const Employee = () => {
  // employee blockchain details
  const [isLoading, setIsLoading] = useState(true);
  const [employee, setEmployee] = useState({
    dueDate: "",
    currentDate: "",
    startDate: "",
    due: false,
  });
  const location = useLocation();
  console.log(location.state);
  const { id } = useParams();
  console.log(id);

  // get due date
  const checkDueDate = async () => {
    const not = toast.loading("⏳ Loading details..");
    const { startDate, dueDate, currentDate, due } = await getDueDate(
      location.state.signerAddy,
      location.state.payId
    );
    setEmployee({
      dueDate: dueDate.toString(),
      currentDate: currentDate.toString(),
      due: due,
      startDate: startDate.toString(),
    });
    toast.success("✅Done", {
      id: not,
    });
  };

  // pay employee
  const pay = async () => {
    try {
      const tronweb = window.tronWeb;
      const notification = toast.loading("⏳ Processing transaction....");

      const contract = await tronweb
        .contract()
        .at(process.env.REACT_APP_companyAddress);

      const pay = await tronweb.toSun(location?.state?.salary);
      console.log(location?.state.signerAddy, location?.state.payId);
      const hash = await contract
        .pay(location?.state.signerAddy, location?.state.payId)
        .send({
          feeLimit: 1000000000,
          callValue: pay,
        });

      toast.loading("⏳ Paying Employee...", {
        id: notification,
      });
      console.log(hash);
      setTimeout(async () => {
        await updateT(
          location.state.email,
          hash,
          true,
          location.state?.name,
          location?.state?.salary
        );
        toast.success("✅ Payment Done", {
          id: notification,
        });
      }, 3000);
    } catch (error) {
      console.log(error);
    }
  };

  // pay employee
  const cancel = async () => {
    try {
      const notification = toast.loading("⏳ Halting payment....");
      const tronweb = window.tronWeb;
      const contract = await tronweb
        .contract()
        .at("TDrxc8oPALmdgLKpnfhQThQvh71QzG3A2p");
      const hash = await contract.cancel(location?.state.payId).send({
        feeLimit: 100_000_000,
        callValue: 0,
      });

      toast.loading("⏳ Removing Employee...", {
        id: notification,
      });
      console.log(hash);
      setTimeout(async () => {
        await updateT(
          location.state.email,
          hash,
          true,
          location.state?.name,
          location?.state?.salary
        );
        toast.success("✅Done", {
          id: notification,
        });
      }, 3000);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    checkDueDate();
  }, []);
  return (
    <>
      <div className="px-6">
        <div className="my-5 py-5 pl-5 bg-[#F3EFE0] rounded-2xl font-semibold">
          <p>About {id}</p>
        </div>
        <div className="space-y-3 py-5">
          <div className="flex items-center space-x-2 py-2 px-4 border-2 w-fit info text-white">
            <p>Name:</p>
            <p className="text-sm">{location.state?.name}</p>
          </div>
          <div className="flex items-center space-x-2 py-2 px-4 border-2 w-fit info1 text-white">
            <p>Department:</p>
            <p className="text-sm">{location.state?.department}</p>
          </div>
          <div className="flex items-center space-x-2 py-2 px-4 border-2 w-fit info2 text-white">
            <p>Start Date:</p>
            <p className="text-sm">{employee.startDate}</p>
          </div>
          <div className="flex items-center space-x-2 py-2 px-4 border-2 w-fit info3 text-white">
            <p>Next Pay:</p>
            <p className="text-sm">{employee.dueDate}</p>
          </div>
          <div className="flex items-center space-x-2 py-2 px-4 border-2 w-fit info4 text-white">
            <p>Address:</p>
            <p className="text-sm">{location.state?.address}</p>
          </div>
          <div className="flex items-center space-x-2 py-2 px-4 border-2 w-fit info5 text-white">
            <p>Salary:</p>
            <p className="text-sm">{location.state?.salary}TRX</p>
          </div>
          <div className="info6 text-white">
            {employee.due ? (
              <>
                <button
                  className="px-4 text-white bg-green-700 py-2 rounded my-2"
                  onClick={pay}
                >
                  Pay
                </button>
                <button
                  className="px-4 text-white bg-red-700 mx-2 py-2 rounded my-2"
                  onClick={cancel}
                >
                  Cancel
                </button>
              </>
            ) : (
              <button
                className="px-4 text-white py-2 bg-red-700 rounded my-2"
                disabled
              >
                Not yet due
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Employee;
